import { TanStackDevtools } from '@tanstack/react-devtools';
import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools';
import FilterDevtoolsPanel from './FilterDevtoolsPanel';

export default function DevtoolsProvider() {
  return (
    <>
      <TanStackDevtools
        config={{ theme: 'light', position: 'top-right', hideUntilHover: true }}
        eventBusConfig={{ debug: true }}
        plugins={[
          {
            name: 'TanStack Query',
            render: <ReactQueryDevtoolsPanel />,
          },
          { name: 'Filters', render: <FilterDevtoolsPanel /> },
        ]}
      />
    </>
  );
}
